import { useRouteError, isRouteErrorResponse } from "react-router";

export default function BridgeRouteErrorBoundary() {
    const err = useRouteError();
    if (isRouteErrorResponse(err)) {
        throw Object.assign(new Error(err.statusText || "Route Error"), {
            status: err.status,
            data: err.data,
        });
    }
    throw (err instanceof Error ? err : new Error(String(err)));
}